var map = {
	"./cp.jpg": "c4ba",
	"./cyber-bullying.jpg": "b17f",
	"./device.jpg": "64ce",
	"./employ_fraud.jpg": "cce6",
	"./guidelines.jpg": "98cf",
	"./literacy.jpg": "078d",
	"./mind.jpg": "333b",
	"./naked_chat.jpg": "46e2",
	"./netiquette.jpg": "9fa4",
	"./online_doxxing.png": "6ff9",
	"./scam.jpg": "154c",
	"./sexual_violence.png": "9cb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e6c";